export const LIFECYCLE_RENEWAL = "Renewal";
export const LIFECYCLE_REFRESH = "Refresh";
export const LIFECYCLE_BILLING = "Billing";

export const LIFECYCLE_EVENT_TYPE_VALUES = [
  LIFECYCLE_RENEWAL,
  LIFECYCLE_REFRESH,
  LIFECYCLE_BILLING,
] as const;
export type LifecycleEventTypeValue = (typeof LIFECYCLE_EVENT_TYPE_VALUES)[number];